import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';

export const myToolsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyTools: builder.query({
      query: (args = {}) => ({
        url: '/api/my_tools',
        params: buildListQueryParams(args),
      }),
      providesTags: ['MyTools'],
    }),
    getMyToolById: builder.query({
      query: (id) => `/api/my_tools/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'MyTools', id }],
    }),
    getMyToolDraft: builder.query({
      async queryFn(_arg, _api, _extraOptions, baseQuery) {
        const result = await baseQuery('/api/my_tools/draft');
        if (result.error) {
          if (result.error.status === 404) return { data: null };
          return { error: result.error };
        }
        return { data: result.data ?? null };
      },
      providesTags: [{ type: 'MyTools', id: 'DRAFT' }],
    }),
    updateMyTool: builder.mutation({
      query: ({ id, body }) => ({
        url: `/api/my_tools/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'MyTools',
        { type: 'MyTools', id },
        { type: 'MyTools', id: 'DRAFT' },
      ],
    }),
    deleteMyTool: builder.mutation({
      query: (id) => ({
        url: `/api/my_tools/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        'MyTools',
        { type: 'MyTools', id },
        { type: 'MyTools', id: 'DRAFT' },
      ],
    }),
    importMyToolCsv: builder.mutation({
      query: ({ file, location_id, date, sales_history_weeks, product_ids, product_type_id }) => {
        const fd = new FormData();
        fd.append('file', file, file.name);
        if (product_type_id != null && String(product_type_id).trim() !== '') {
          fd.append('product_type_id', String(product_type_id));
        }
        if (location_id != null && String(location_id).trim()) {
          fd.append('location_id', String(location_id));
        }
        if (date != null && String(date).trim()) {
          fd.append('date', String(date));
        }
        if (sales_history_weeks != null && String(sales_history_weeks).trim()) {
          fd.append('sales_history_weeks', String(sales_history_weeks));
        }
        (Array.isArray(product_ids) ? product_ids : []).forEach((id) => {
          const value = String(id ?? '').trim();
          if (value) fd.append('product_ids[]', value);
        });
        return {
          url: '/api/my_tools/import_csv',
          method: 'POST',
          body: fd,
        };
      },
      invalidatesTags: ['MyTools'],
    }),
  }),
});

export const {
  useGetMyToolsQuery,
  useGetMyToolByIdQuery,
  useLazyGetMyToolByIdQuery,
  useLazyGetMyToolDraftQuery,
  useUpdateMyToolMutation,
  useDeleteMyToolMutation,
  useImportMyToolCsvMutation,
} = myToolsApi;
